/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const variable = project.getFeature(feature.getSettingValue('VARIABLE'));
    const FUNCNAME = feature.getSettingValue('FUNCNAME');
    const CODE = feature.getSettingValue('CODE');
    const blockId = feature.getID();
    let evaluationCode = '';
    let variableType = 'string';
    if (variable) {
        variableType = variable.getSettingValue('DATATYPE');
    }

    const links = project.getNodeLinks(feature, 'set_value');
    if (links.length > 0) {
        evaluationCode = feature.project.parseCodeExpression(CODE, [], null);
    }
    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        if (variable) {
            const VARNAME = variable.getSettingValue('VARNAME');
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `var_${VARNAME}_set(${FUNCNAME}())`,
            });
        } else {
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `${FUNCNAME}()`,
            });
        }
        const tmpLinks = project.getNodeLinks(feature, 'math_done');
        if (tmpLinks.length > 0) {
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: `${link.getID()}_done`,
                template: `#****${feature.getID()}_math_done****#`,
            });
        }
    }

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.CODE,
        id: `${blockId}_body`,
        template: `
def ${FUNCNAME}():
    ${evaluationCode}
    pass`,
    });

    return blocks;
};
